import type { DefaultAttributeValue } from '@source-components-react/types';
import { PLACEHOLDER_ICON } from './icon-attribute-value';

export const defaultAttributeValues: DefaultAttributeValue[] = [
  {
    // Holds `{ name, iconNode }`, not a bare name: the composer stamps the
    // geometry when the author picks the icon so the render path never needs
    // the icon registry.
    name: 'icon-name-3-resolutions',
    defaultValues: {
      all: PLACEHOLDER_ICON,
    },
  },
];
